import { useState } from "react";
// import { Dayjs } from "dayjs";
// import DateRangePicker from "./components/DateRangePickerComponent";
import { fetchGetReporteEstadosDeCuentasClientes } from "../services/reporteService";
import { useUserContext } from "../hooks/UserContext";
import { useNotification } from "../hooks/NotificationContext";
import DynamicGrid from "../components/DynamicTable";
import LocalSelector from "./components/LocalSelector";
import {
  CircularProgress,
  Button,
  Box,
  Grid,
  Typography,
  Paper,
  Stack,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { EstadosCuentasCorrientesClientes, reporteEstadosDeCuentasClientesGridColumnDefinitions } from "../models/ReporteEstadosCuentasClientesModel";
import { ClienteCuentaCorrienteDto, fetchDescargarCuentaCorrientePdf, fetchGetCuentaCorrienteCliente } from "../services/clienteService";
import { CurrencyFormatter } from "../utils/CurrencyFormatter";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const field = (row: any, ...keys: string[]) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
  }
  return "";
};

const moneyText = (value: string | number | undefined) => {
  const raw = String(value ?? "").trim();
  if (!raw) return CurrencyFormatter.format(0);
  const normalized = Number(raw.replace(/\$/g, "").replace(/\./g, "").replace(",", "."));
  return Number.isFinite(normalized) ? CurrencyFormatter.format(normalized) : raw;
};

const ReporteEstadosCuentasClientes = () => {
  const { getUser } = useUserContext();
  const { showNotification } = useNotification();
  const [idLocal, setIdLocal] = useState<string | undefined>(undefined);
  const [loadingReporte, setLoadingReporte] = useState(false);
  const [loadingDetalle, setLoadingDetalle] = useState(false);
  const [descargandoPdf, setDescargandoPdf] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState<EstadosCuentasCorrientesClientes | null>(null);
  const [cuentaCorriente, setCuentaCorriente] = useState<ClienteCuentaCorrienteDto | null>(null);
  const [reporteEstadosDeCuentasClientes, setReporteEstadosDeCuentaClientes] = useState<EstadosCuentasCorrientesClientes[]>([]);
//   const [selectedRange, setSelectedRange] = useState<{ startDate: Dayjs | null; endDate: Dayjs | null }>({
//     startDate: null,
//     endDate: null,
//   });

//   const handleDateChange = (range: { startDate: Dayjs | null; endDate: Dayjs | null }) => {
//     setSelectedRange(range);
//   };

  const handleLocalChange = (idLocal: string | undefined) => {
    setIdLocal(idLocal);
  };

  const getReporteDeEstadosDeCuentasClientes = () => {
    if (idLocal) {
      setLoadingReporte(true);
      fetchGetReporteEstadosDeCuentasClientes(idLocal, getUser()!)
        .then((res: EstadosCuentasCorrientesClientes[]) => {
          setReporteEstadosDeCuentaClientes(res);
          setClienteSeleccionado(null);
          setCuentaCorriente(null);
          setLoadingReporte(false);
        })
        .catch((err) => {
          setLoadingReporte(false);
        });
    }
  };

  const cargarDetalleCliente = (rowParams: any) => {
    const row = rowParams?.row ?? {};
    const idCliente = Number(field(row, "IDCLIENTE", "idcliente", "idCliente"));
    if (!idCliente) {
      showNotification("No se pudo identificar el cliente seleccionado", "warning");
      return;
    }

    const cliente = reporteEstadosDeCuentasClientes.find((item: any) =>
      Number(field(item, "IDCLIENTE", "idcliente", "idCliente")) === idCliente
    ) ?? row;

    setClienteSeleccionado(cliente as EstadosCuentasCorrientesClientes);
    setLoadingDetalle(true);
    fetchGetCuentaCorrienteCliente(getUser()!, idCliente)
      .then(setCuentaCorriente)
      .catch((err) => {
        console.log(err);
        showNotification(err?.message ?? "No se pudo cargar el detalle de cuenta corriente", "error");
      })
      .finally(() => setLoadingDetalle(false));
  };

  const descargarPdfCliente = () => {
    if (!clienteSeleccionado) return;

    const idCliente = Number(field(clienteSeleccionado, "IDCLIENTE", "idcliente", "idCliente"));
    const cliente = String(field(clienteSeleccionado, "CLIENTE", "cliente"));
    if (!idCliente) {
      showNotification("No se pudo identificar el cliente seleccionado", "warning");
      return;
    }

    setDescargandoPdf(true);
    fetchDescargarCuentaCorrientePdf(getUser()!, idCliente, cliente)
      .catch((err) => {
        console.log(err);
        showNotification(err?.message ?? "No se pudo descargar el PDF", "error");
      })
      .finally(() => setDescargandoPdf(false));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Reporte de Estados de Cuentas Corrientes de Clientes
      </Typography>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        {/* <Grid item xs={12} sm={6} md={4}>
          <DateRangePicker onDateChange={handleDateChange} />
        </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <LocalSelector onLocalChange={handleLocalChange} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            onClick={getReporteDeEstadosDeCuentasClientes}
            variant="contained"
            color="primary"
            fullWidth
            disabled={loadingReporte}
            startIcon={loadingReporte ? <CircularProgress color="inherit" size={18} /> : undefined}
            sx={{ height: "100%" }}
          >
            {loadingReporte ? "Obteniendo..." : "Obtener Reporte"}
          </Button>
        </Grid>
      </Grid>
      <DynamicGrid
        data={reporteEstadosDeCuentasClientes}
        customHeaderMap={reporteEstadosDeCuentasClientesGridColumnDefinitions}
        pageSize={10}
        removeIfNotCustom={true}
        rowClickEventHandler={cargarDetalleCliente}
      />
      {clienteSeleccionado && (
        <Box sx={{ mt: 3 }}>
          <Paper sx={{ p: 2, mb: 2, borderRadius: 2 }}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }}>
              <Box>
                <Typography variant="h6">{field(clienteSeleccionado, "CLIENTE", "cliente")}</Typography>
                <Typography color="text.secondary">Detalle de cuenta corriente</Typography>
              </Box>
              <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
                <Chip label={`Saldo ${moneyText(cuentaCorriente?.saldo)}`} color="primary" />
                <Chip label={`Deuda ${moneyText(cuentaCorriente?.totalDeuda)}`} color="warning" variant="outlined" />
                <Chip label={`Debe ${moneyText(cuentaCorriente?.totalDebe)}`} size="small" />
                <Chip label={`Haber ${moneyText(cuentaCorriente?.totalHaber)}`} size="small" />
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={descargandoPdf ? <CircularProgress color="inherit" size={16} /> : <PictureAsPdfIcon />}
                  disabled={descargandoPdf || loadingDetalle}
                  onClick={descargarPdfCliente}
                >
                  {descargandoPdf ? "Generando..." : "PDF"}
                </Button>
              </Stack>
            </Stack>
          </Paper>

          <Grid container spacing={2}>
            <Grid item xs={12} lg={5}>
              <Paper sx={{ borderRadius: 2, overflow: "hidden" }}>
                <Box sx={{ p: 2 }}>
                  <Typography variant="h6">Facturas pendientes</Typography>
                </Box>
                <TableContainer sx={{ maxHeight: 360 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha</TableCell>
                        <TableCell>Comprobante</TableCell>
                        <TableCell align="right">Total</TableCell>
                        <TableCell align="right">Deuda</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loadingDetalle ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center"><CircularProgress size={18} sx={{ my: 2 }} /></TableCell>
                        </TableRow>
                      ) : !cuentaCorriente?.facturasImpagas?.length ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center">No hay facturas pendientes.</TableCell>
                        </TableRow>
                      ) : cuentaCorriente.facturasImpagas.map((factura: any) => (
                        <TableRow key={`${field(factura, "id", "ID")}-${field(factura, "idlocal", "IDLOCAL")}`}>
                          <TableCell>{field(factura, "fecha_OPERACION", "fechA_OPERACION", "FECHA_OPERACION")}</TableCell>
                          <TableCell>{field(factura, "tipo_DE_FACTURA", "tipO_DE_FACTURA", "TIPO_DE_FACTURA")} {field(factura, "factura", "FACTURA")}</TableCell>
                          <TableCell align="right">{moneyText(field(factura, "total", "TOTAL"))}</TableCell>
                          <TableCell align="right">{moneyText(field(factura, "deuda", "DEUDA"))}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>

            <Grid item xs={12} lg={7}>
              <Paper sx={{ borderRadius: 2, overflow: "hidden" }}>
                <Box sx={{ p: 2 }}>
                  <Typography variant="h6">Estado de cuenta</Typography>
                </Box>
                <TableContainer sx={{ maxHeight: 360 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha</TableCell>
                        <TableCell>Comprobante</TableCell>
                        <TableCell align="right">Debe</TableCell>
                        <TableCell align="right">Haber</TableCell>
                        <TableCell align="right">Saldo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loadingDetalle ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center"><CircularProgress size={18} sx={{ my: 2 }} /></TableCell>
                        </TableRow>
                      ) : !cuentaCorriente?.estadoCuenta?.length ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">No hay movimientos.</TableCell>
                        </TableRow>
                      ) : cuentaCorriente.estadoCuenta.map((mov, index) => (
                        <TableRow key={`${mov.fecha}-${mov.hora}-${index}`}>
                          <TableCell>{mov.fecha}</TableCell>
                          <TableCell>{mov.comprobante}</TableCell>
                          <TableCell align="right">{moneyText(mov.debe)}</TableCell>
                          <TableCell align="right">{moneyText(mov.haber)}</TableCell>
                          <TableCell align="right">{moneyText(mov.saldo)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ReporteEstadosCuentasClientes;
